<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="الشارقة-1974">
<h1><span dir="rtl">الشَّارقة 1974</span></h1>
<p style="text-indent:001em;"><span dir="rtl">"هاشم الهاشم" عراقيّ ويحمل جنسيَّةً ألمانيَّةً، غادر بلده العراق قبل سنواتٍ واستقرَّ في ألمانيا عند خاله، وبعد فترةٍ انفصل عن عمل العائلة وبدأ بتِجارته الخاصَّة.</span></p>
<p><span dir="rtl">اليوم أصبح هاشم في الأربعين من عُمره، لم يتغيَّر كثيرًا عمّا كان عليه قبل خمس عشرة سنةً، غير أنَّ الزَّمن ترك على جسده بعض آثاره؛ مثل فِقْدان الحركة في أحد أصابع يده اليُسرى بعد أن أُصيب برصاصةٍ في يده،</span></p>
<p><span dir="rtl">وتغيَّر لون شعره الأسود بعد أن غزَت الخُصَل البيضاء رأسه وأصبح اللَّون الرّماديّ طاغيًا مع احتفاظه بكثافته ومع بعض العلامات التي اكتسبها في مُواجهاته المباشِرة مع مُنافسيه، وقد ترك بعضُ خصومه آثارَهم على وجهه وفي أماكنَ متفرِّقةٍ في جسده، عجزت السّنوات عن مسح آثار تلك النُّدوبِ من على جِسمه ومن ذاكِرته.</span></p>
<p><span dir="rtl">كان "هاشم" كباقي أحفاد "رفعت الهاشم" الَّذين ورِثوا من والِد جدّهم الملامِح والبُنية الجسمانيَّة لأهل نجد، ومن أمّ جدّه بَشَرة الشُّعوب القوقازيّة والعيونِ الملوَّنة.</span></p>
<p><span dir="rtl">- تأخَّرت!</span></p>
<p><span dir="rtl">أخرجَ "مَعْنٌ" عُلبتين كان يخبّئهما.</span></p>
<p><span dir="rtl">- ما هذا؟</span></p>
<p><span dir="rtl">- هدايا عيد ميلادِ الستّ شهد.</span></p>
<p><span dir="rtl"><br/>
</span></p>
<p><span dir="rtl">وضعَ هاشمٌ يده على رأسه قائلًا:</span></p>
<p><span dir="rtl">- نسيتُ عيد ميلادها تمامًا! لا أعرف ماذا كنت سأفعل بدونك يا مَعْن؟!</span></p>
<p><span dir="rtl">- لتعرف فقط بأنَّك لا تستطيع عملَ شيءٍ بدوني.</span></p>
<p><span dir="rtl">ابتسم هاشم ثمَّ سأله:</span></p>
<p><span dir="rtl">- أرى عُلبتين في يدك!</span></p>
<p><span dir="rtl">- هديَّتي لشهد خانم، أم أنَّك تريدها أن تغضب من عمِّها "مَعْن"!</span></p>
<p><span dir="rtl">ضحك هاشم عندما سمع من مَعْن طريقة نطقِ شهد لاسمه، ثمَّ نظر إلى ساعة يده:</span></p>
<p><span dir="rtl">- بقيَت نصف ساعةٍ على المُباراة، لنذهب!</span></p>
<p><span dir="rtl">تذكَّر هاشم أمرًا وقال:</span></p>
<p><span dir="rtl">- ها، قبل أن أنسى، إيّاك أن تسخر من طريقتها في الكلام، فهذا لا يُعجبها!</span></p>
<p><span dir="rtl">- لا داعي لأنْ تُذكِّرني، لأنّني إنْ نسيتُها ذكّرَتني هي بها.</span></p>
<p><span dir="rtl">استوقفه مَعْن:</span></p>
<p><span dir="rtl">- قبل أن نذهب أريد أن أطلب منك شيئًا؛</span></p>
<p><span dir="rtl">- تفضّل!</span></p>
<p><span dir="rtl">- أريد أن أسافر إلى الأردن، لم أرَ وَلَدَيْ عمّي منذ مدَّةٍ وأريد الاطمئنان عليهما وقضاء بعض الوقت معهما.</span></p>
<p><span dir="rtl">شعر هاشم ببعض التَّقصير تجاه مَعْن:</span></p>
<p><span dir="rtl">- سامِحني يا مَعْن!</span></p>
<p><span dir="rtl">- على ماذا؟</span></p>
<p><span dir="rtl">- شَغلتُك عنهُما بأعمالي وثأري.</span></p>
<p><span dir="rtl">- أنسيتَ بأنَّه ثأري أيضًا؟ شيءٌ آخرٌ يجب أن تعرفه يا هاشم؛</span></p>
<p><span dir="rtl">- ما هو؟</span></p>
<p><span dir="rtl">- أنا اخترت أن أكون معكَ بكلِّ إرادتي، كما كان عمّي وقبله جدّي مع عائِلتك.</span></p>
<p><span dir="rtl">شعرَ بارتياحٍ:</span></p>
<p><span dir="rtl">- أسعدَني سماع هذا منك، لكِن الأمرُ لم ينتهِ بعدُ!</span></p>
<p><span dir="rtl">استغربَ مَعْنٌ:</span></p>
<p><span dir="rtl">- ماذا بقي؟</span></p>
<p><span dir="rtl">- زواجك.</span></p>
<p><span dir="rtl">- أوف! أرجِعنا لنفس الموضوع؟!</span></p>
<p><span dir="rtl">- نحن لم ننتهِ منه، كأنَّك نسيتَ وعدي للسيّدة مارسيل!</span></p>
<p><span dir="rtl">يقولُ مَعْن مُغيّرًا الموضوع:</span></p>
<p><span dir="rtl">- ألم تقُلْ بأننا تأخَّرنا عن المباراة؟</span></p>
<p><span dir="rtl"><br/>
</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?d8bb1ac4